module.exports = __webpack_public_path__ + "static/media/miloscicLogo.b2f101ed.png";